module.exports = __webpack_public_path__ + "img/headphone.174ab9bb.svg";